module.exports = __webpack_public_path__ + "static/img/5ban.d111026a.png";